import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import { IoInformation } from "react-icons/io5";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import ArrowForwardOutlinedIcon from "@material-ui/icons/ArrowForwardOutlined";
import axios from "../../../../axios";
import apiError from "../../../../error";
import Spinner from "../../../spinner/spinner";
import CreatableSelect from "react-select/creatable";
import credentialHarvestingImg from "../../../../assets/create_campaign/credHarvesting.png";
import aivishingImg from "../../../../assets/create_campaign/aivishing.png";
import vishingImg from "../../../../assets/create_campaign/vishing.png";
import whatsappImgIVR from "../../../../assets/create_campaign/whatsapp-ivr.png";
import whatsappImgChatbox from "../../../../assets/create_campaign/chatbox.png";

import "./campaign-name.css";

export default class CampaignName extends Component {
	constructor(props) {
		super(props);
		this.state = {
			categories: [],
			languages: [],
		};
		this.loadCategory();
		this.loadLanguage();
	}

	handleTargetInteractionType = (type) => {
		if (this.props.handleTargetInteractionType) {
			this.props.handleTargetInteractionType(type);
		}
	};
	handleAIbased = (type) => {
		if (this.props.handleAIbased) {
			this.props.handleAIbased(type);
		}
	};

	loadCategory = () => {
		axios.get("/api/campaign/template/category", {})
			.then((res) => {
				this.setState({ categories: res.data.categories });
			})
			.catch((err) => apiError(err));
	};

	loadLanguage = () => {
		axios
			.get("/api/campaign/template/language", {})
			.then((res) => {
				this.setState({ languages: res.data.languages });
			})
			.catch((err) => apiError(err));
	};

	render() {
		const { tags } = this.props;
		return (<Form>
			<div className="cmpaigntemplateBox-ai">
				<div className='rightSectionHeader'>
					<div className="row justify-content-between align-items-center">
						<div className="col-md-4 tab-right-header">
							<h6>Template Details</h6>
							<p>Configure basic template information</p>
						</div>
					</div>
				</div>
				<div className="borderDashed">
					<div>
						<p className="blueText">Information</p>
					</div>
					<div className="row ">
						<div className="col-md-4">
							<Form.Group>
								<Form.Label>Template Name<span className="red-star">*</span></Form.Label>
								<Form.Control
									type="text"
									value={this.props.templateName}
									onChange={this.props.handleCampaignName}
									placeholder="Enter Template Name"
								/>
							</Form.Group>
						</div>
						<div className="col-md-4">
							<Form.Group>
								<Form.Label>
									Category<span className="red-star">*</span>
									<OverlayTrigger placement="top" overlay={<Tooltip id="top">These are the categories of attack templates</Tooltip>}>
										<IoInformation className="tooltip-icon"></IoInformation>
									</OverlayTrigger>
								</Form.Label>
								<Form.Control value={this.props.categoryId} onChange={this.props.handleCategoryId} as="select">
									<option value="0" disabled>Select Template Category</option>
									{this.state.categories.map((category, index) => {
										return (
											<option key={index} value={category.id}>
												{category.name}
											</option>
										);
									})}
								</Form.Control>
							</Form.Group>
						</div>
						<div className="col-md-4">
							<Form.Group>
								<Form.Label>
									Language<span className="red-star">*</span>
									<OverlayTrigger
										placement="top"
										overlay={<Tooltip id="top">This will be only for labelling purpose/This will label your attack template</Tooltip>}
									>
										<IoInformation className="tooltip-icon"></IoInformation>
									</OverlayTrigger>
								</Form.Label>
								<Form.Control value={this.props.languageId} onChange={this.props.handleLanguageId} as="select">
									<option value="0" disabled>Select Language</option>
									{this.state.languages.map((language, index) => {
										return (
											<option key={index} value={language.id}>
												{language.name}
											</option>
										);
									})}
								</Form.Control>
							</Form.Group>
						</div>
					</div>
				</div>

				<div className="borderDashed">
					<div className="row">
						<div className="col-md-4">
							<Form.Group>
								<Form.Label>
									Type of Simulation<span className="red-star">*</span>
									<OverlayTrigger placement="top" overlay={<Tooltip id="top">These are the categories of simulation</Tooltip>}>
										<IoInformation className="tooltip-icon"></IoInformation>
									</OverlayTrigger>
								</Form.Label>
								<Form.Control
									as="select"
									disabled={this.props.disableState}
									value={JSON.stringify({ id: this.props.simulationTypeId, name: this.props.simulationTypeName })}
									onChange={this.props.handleSimulationType}
								>
									<option value={JSON.stringify({ id: -1, name: "" })} disabled>Select Simulation Type</option>
									{this.props.simulation_type.map((type, index) => {
										return (
											<option key={index} disabled={!type.active} value={JSON.stringify({ id: type.id, name: type.name })}>
												{type.name}
											</option>
										);
									})}
								</Form.Control>
							</Form.Group>
						</div>
						<div className="col-md-4">
							<Form.Group>
								<Form.Label>
									Attack Vector<span className="red-star">*</span>
									<OverlayTrigger placement="top" overlay={<Tooltip id="top">Different type of cyber Attack</Tooltip>}>
										<IoInformation className="tooltip-icon"></IoInformation>
									</OverlayTrigger>
								</Form.Label>
								<Form.Control
									as="select"
									disabled={this.props.disableState}
									value={JSON.stringify({ id: this.props.attackTypeId, name: this.props.attackTypeName })}
									onChange={this.props.handleAttackType}
								>
									<option value={JSON.stringify({ id: -1, name: "" })} disabled>Select Attack Type</option>
									{this.props.attack_type.map((vector, index) => {
										return (
											<>
												<option key={index} value={JSON.stringify({ id: vector.attack_type.id, name: vector.attack_type.name })}>
													{vector.attack_type.name}
												</option>
											</>
										);
									})}
								</Form.Control>
							</Form.Group>
						</div>
						<div className="col-md-4">
							<label className="form-label">Enter Tags</label>
							<CreatableSelect
								isMulti
								isClearable
								value={tags}
								onChange={(newValue) => this.props.setTags(newValue || [])}
								placeholder="Type tag and press Enter..."
								styles={{
									control: (base, state) => ({
										...base,
										borderColor: "#ced4da",
										boxShadow: "none",
										"&:hover": {
											borderColor: "#ced4da",
										},
									}),
									placeholder: (base) => ({
										...base,
										fontSize: "0.875rem",
										color: "#6c757d",
									}),
									multiValue: (base) => ({
										...base,
										backgroundColor: "#e2e3e4",
									}),
									multiValueLabel: (base) => ({
										...base,
										color: "#212529",
									}),
									multiValueRemove: (base) => ({
										...base,
										color: "#000",
										cursor: "pointer",
										":hover": {
											backgroundColor: "#999",
											color: "#fff",
										},
									}),
								}}
							/>
						</div>
					</div>
				</div>

				{this.props.attackTypeName === "Vishing" && (() => {
				const isVishingAISelected = this.props.targetInteractionType === "inbound";
				const isVishingIVRSelected = this.props.targetInteractionType === "outbound";
				const lockEditMode = !!this.props.campaignTemplateId;
				const ivrCardLocked = lockEditMode && isVishingAISelected;
				const aiVishingCardLocked = lockEditMode && isVishingIVRSelected;
				return (
					<div className="vishing-options-wrapper mt-3">
						<div className="row">
							<div className="col-md-6 mb-3">
									<div
									className={`vishing-card ${isVishingIVRSelected ? 'active' : ''}${ivrCardLocked ? ' disabled' : ''}`}
									onClick={() => !this.props.campaignTemplateId && this.handleAIbased(false)}
									style={{ cursor: lockEditMode ? 'not-allowed' : '' }}
									aria-disabled={ivrCardLocked}
								>
									<div className="vishing-img-wrapper">
										<img src={vishingImg} alt="IVR" />
									</div>
									<div className="vishing-content">
										<div className="vishing-title">IVR (Keypad-based)</div>
										<div className="vishing-desc">Automated pre-recorded calls that attempt to extract information using keypad inputs</div>
									</div>
									<div className="vishing-radio">
										<input type="radio" checked={isVishingIVRSelected} readOnly />
									</div>
								</div>
							</div>
							<div className="col-md-6 mb-3">
									<div
									className={`vishing-card ${isVishingAISelected ? 'active' : ''}${aiVishingCardLocked ? ' disabled' : ''}`}
									onClick={() => !this.props.campaignTemplateId && this.handleAIbased(true)}
									style={{ cursor: lockEditMode ? 'not-allowed' : '' }}
									aria-disabled={aiVishingCardLocked}
								>
									<div className="vishing-img-wrapper">
										<img src={aivishingImg} alt="AI" />
									</div>
									<div className="vishing-content">
										<div className="vishing-title">AI Conversational (Voice Bot)</div>
										<div className="vishing-desc">Human-like AI voice interaction that dynamically engages users to extract sensitive information.</div>
									</div>
									<div className="vishing-radio">
										<input type="radio" checked={isVishingAISelected} readOnly />
									</div>
								</div>
							</div>
						</div>
					</div>
				);
				})()}

				{this.props.attackTypeName === "WhatsApp" && (() => {
				const isWhatsappAISelected = this.props.targetInteractionType === "inbound" && this.props.isAIbased === true;
				const isWhatsappNormalSelected = this.props.targetInteractionType === "outbound" || this.props.isAIbased === false;
				const lockEditMode = !!this.props.campaignTemplateId;
				const directWaCardLocked = lockEditMode && this.props.isAIbased === true;
				const aiWaCardLocked = lockEditMode && this.props.isAIbased === false;
				return (
					<div className="vishing-options-wrapper mt-3">
						<h5 className="section-title">WhatsApp Phishing Mode</h5>
						<div className="row">
							<div className="col-md-6 mb-3">
								<div
									className={`vishing-card ${isWhatsappNormalSelected ? 'active' : ''}${directWaCardLocked ? ' disabled' : ''}`}
									onClick={() => !this.props.campaignTemplateId && this.handleAIbased(false)}
									style={{ cursor: lockEditMode ? 'not-allowed' : '' }}
									aria-disabled={directWaCardLocked}
								>
									<div className="vishing-img-wrapper">
										<img src={whatsappImgIVR} alt="WhatsApp" />
									</div>
									<div className="vishing-content">
										<div className="vishing-title">Direct WhatsApp Message</div>
										<div className="vishing-desc">Send tracked WhatsApp messages from the configured messaging gateway.</div>
									</div>
									<div className="vishing-radio">
										<input type="radio" checked={isWhatsappNormalSelected} readOnly />
									</div>
								</div>
							</div>
							<div className="col-md-6 mb-3">
								<div
									className={`vishing-card ${isWhatsappAISelected ? 'active' : ''}${aiWaCardLocked ? ' disabled' : ''}`}
									onClick={() => !this.props.campaignTemplateId && this.handleAIbased(true)}
									style={{ cursor: lockEditMode ? 'not-allowed' : '' }}
									aria-disabled={aiWaCardLocked}
								>
									<div className="vishing-img-wrapper">
										<img src={whatsappImgChatbox} alt="AI WhatsApp" />
									</div>
									<div className="vishing-content">
										<div className="vishing-title">AI Conversational (Chat Bot)</div>
										<div className="vishing-desc">Send an email with a tracked WhatsApp link, then continue the interaction in AI chat.</div>
									</div>
									<div className="vishing-radio">
										<input type="radio" checked={isWhatsappAISelected} readOnly />
									</div>
								</div>
							</div>
						</div>
					</div>
				);
				})()}

				{   this.props.attackTypeName &&
					this.props.attackTypeName.length &&
					!(this.props.attackTypeName === "Vishing" && this.props.targetInteractionType !== "inbound") &&
					this.props.attackTypeName !== "Training + Quiz" &&
					this.props.attackTypeName !== "Ransomware" &&
					this.props.attackTypeName !== "Attachment" ? (
					<div className="form-section template-details-configuration">
						<p className="blueText">Configuration</p>
						<div className="template-toggle-options">
							<div className="template-toggle-option">
								<div className="template-toggle-option-content">
									<div className="template-toggle-icon">
										<img src={credentialHarvestingImg} alt="Credential Harvesting" />
									</div>
									<div className="template-toggle-text">
										<h6>Credential Harvesting</h6>
										<p>Simulate credential submission to identify users who attempt to share login information</p>
									</div>
								</div>
								<Form.Check
									type="switch"
									id="templateCredentialHarvesting"
									checked={!!this.props.credential_harvesting}
									onChange={this.props.handleHarvesting}
								/>
							</div>
						</div>
					</div>
				) : null}
			</div>
			<div className="capFooter text-right" style={{ paddingRight: "0px" }}>
				<Button
					className="btn btn-success ml-2"
					variant="success"
					disabled={this.props.campaignNameLoading || !this.props.showNextTab}
					type="button"
					onClick={this.props.handleCreateCampaignTemplate}
				>
					{this.props.campaignNameLoading ?
						<Spinner loading={true}>{" "}</Spinner> :
						<ArrowForwardOutlinedIcon className="btn-icon"></ArrowForwardOutlinedIcon>
					}
					Go To Next
				</Button>
			</div>
		</Form>
		);
	}
}
